module.exports = __webpack_public_path__ + "img/signup-guide-01-05.b02b764f.png";